/**
 * 此文件用于表单验证器
 */

/**
 *  验证表单数字区间
 */
let verifyInterval = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('年龄不能为空'));
  }
  setTimeout(() => {
    if (!Number.isInteger(value)) {
      callback(new Error('请输入数字值'));
    } else {
      if (value < 18) {
        callback(new Error('必须年满18岁'));
      } else {
        callback();
      }
    }
  }, 1000);
};


/**
 * 手机号码校验
 */
let phoneNumber = (rule, value, callback)=>{
  if (value && (!(/^[1][3456789]\d{9}$/).test(value) || !(/^[1-9]\d*$/).test(value) || value.length !== 11)) {
    callback(new Error('请输入正确手机号码'))
  } else {
    callback()
  }
}

/**
 * 电话号码校验
 */
let telephoneNumber = (rule, value, callback)=>{
  if (value && (!(/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/).test(value))) {
    callback(new Error('请输入正确的联系方式'))
  } else {
    callback()
  }
}

export default { verifyInterval ,phoneNumber,telephoneNumber};



// WEBPACK FOOTER //
// ./src/utils/validator.js